import CryptoJS from 'crypto-js';
import { btoa, atob, showAlert } from '../../lib/helpers';
import { postApi } from '../../lib/fetcher';
import { api, handleFailedBulk, handleUpdateProcess, handleStatusSuccess } from './constants';
import mutations from './mutations';
import state from './state';

const changePIC = {
  namespaced: true,
  state,
  mutations,
  actions: {

    async getInputerData(ctx, { date, userID, role}) {

      ctx.commit('setLoadingInputer', true);
      
      const data = JSON.stringify({
        search: { userID, role},
        sort_by: 'userID asc',
        limit: '50',
        page: '1',
        version: btoa(
          CryptoJS.SHA256(
            `${'501'}${date}${atob(
              process.env.VUE_APP_STRING_EXTRA1.slice(0, -3)
            )}`
          ).toString()
        ),
      });
      
      const urlApi = api.GET_USER_ROLE;
      
      const responseData = await postApi(ctx, urlApi, data,);
      
      if (responseData?.code === 200) {
        ctx.commit('setInputerData',  { payload: responseData.data.list });
      }
      ctx.commit('setLoadingInputer', false);
    },

    async getApprover1Data(ctx, { date, userID, role}) {
      ctx.commit('setLoadingApprover1', true);
      
      const data = JSON.stringify({
        search: { userID, role},
        sort_by: 'userID asc',
        limit: '50',
        page: '1',
        version: btoa(
          CryptoJS.SHA256(
            `${'501'}${date}${atob(
              process.env.VUE_APP_STRING_EXTRA1.slice(0, -3)
            )}`
          ).toString()
        ),
      });
      
      const urlApi = api.GET_USER_ROLE;
      
      const responseData = await postApi(ctx, urlApi, data,);
      
      if (responseData?.code === 200) {
        ctx.commit('setApprover1Data',  { payload: responseData.data.list });
      }
      ctx.commit('setLoadingApprover1', false);
    },
    async getApprover2Data(ctx, { date, userID, role}) {
      ctx.commit('setLoadingApprover2', true);
      
      const data = JSON.stringify({
        search: { userID, role},
        sort_by: 'userID asc',
        limit: '50',
        page: '1',
        version: btoa(
          CryptoJS.SHA256(
            `${'501'}${date}${atob(
              process.env.VUE_APP_STRING_EXTRA1.slice(0, -3)
            )}`
          ).toString()
        ),
      });
      
      const urlApi = api.GET_USER_ROLE;
      
      const responseData = await postApi(ctx, urlApi, data,);
      
      if (responseData?.code === 200) {
        ctx.commit('setApprover2Data',  { payload: responseData.data.list });
      }
      ctx.commit('setLoadingApprover2', false);
    },
    async fetchMerchants(
      ctx,
      { date, page, itemsPerPage, search }
    ) {
      ctx.commit('clearMerchants');
      ctx.commit('setLoadingPic', true);


      const data = JSON.stringify({
        search,
        sort_by: 'id ASC',
        limit: itemsPerPage.toString(),
        page: page.toString(),
        version: btoa(
          CryptoJS.SHA256(
            itemsPerPage.toString() +
              page.toString() +
              date +
              atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });

      const urlApi = `/index.php?r=api/v1/change_pic/pic/index`;

      const responseData = await postApi(ctx, urlApi, data);

      if (responseData?.code === 200) {
        ctx.commit('setTotalMerchants', {
          payload: responseData,
        });
        ctx.commit('setMerchants', { payload: responseData });
        ctx.commit('setLoadingPic', false);
      }
    },

    async bulkSwitch(ctx, { date, data: Data, options, search }) {

      handleUpdateProcess(ctx);
      
      const intervalId = setInterval(() => {
        const currentPercentage = ctx.state.percentage;
        if (currentPercentage < 80) {
          ctx.commit('setPercentage', currentPercentage + 1);
        } else {
          clearInterval(intervalId); 
        }
      }, 100);
    
      ctx.commit('setIntervalInsert', intervalId);
    
      const remark = `Bulk Switch by ${JSON.parse(localStorage.getItem('logged_in_qram')).user.username}`;
    
      const data = JSON.stringify({
        data: Data,
        remark,
        version: btoa(
          CryptoJS.SHA256(
            date + atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
    
      const urlApi = api.BULK_SWITCH_PIC;
    
      try {
        const responseData = await postApi(ctx, urlApi, data);
    
        if (responseData?.code === 200) {
          if (responseData.data?.message) {
            showAlert(ctx, responseData.data.message, 'mdi-alert', 'red');
            ctx.commit('setPercentage', 0);
            ctx.commit('setProgressColor', 'red');
            clearInterval(intervalId);
            return;
          }
          clearInterval(intervalId);
          ctx.commit('setPercentage', 80);
          ctx.commit('setSwitchData', responseData.data);
    
          const interval = setInterval(() => {
            ctx.dispatch('switchStatus', { date, options, search });
          }, 1000);
          ctx.commit('setIntervalSwitch', interval);
        } else {
          throw new Error('Bulk Switch Failed');
        }
      } catch (error) {
        handleFailedBulk(ctx, intervalId);
      }
    },
    
    async switchStatus(ctx, { date, options, search }) {
      const data = JSON.stringify({
        export_id: ctx.state.switchId,
        count_data: ctx.state.countDataSwitch,
        version: btoa(
          CryptoJS.SHA256(
            ctx.state.switchId.toString() +
            ctx.state.countDataSwitch.toString() +
            date +
            atob(process.env.VUE_APP_STRING_EXTRA1.slice(0, -3))
          ).toString()
        ),
      });
    
      const urlApi = api.BULK_SWITCH_STATUS;
    
      try {
        const responseData = await postApi(ctx, urlApi, data);
    
        if (['11', '10'].includes(responseData?.code)) {
          clearInterval(ctx.state.intervalSwitch);
          handleStatusSuccess(ctx);
          showAlert(ctx, 'Switch Successfully !', 'mdi-check-circle', 'green');
          ctx.dispatch('fetchMerchants', {
            date,
            page: options.page,
            itemsPerPage: options.itemsPerPage,
            sortBy: options.sortBy,
            sortDesc: options.sortDesc,
            search,
          });
   
        } else if (responseData?.code === '302') {
          showAlert(ctx, 'Switch Failed!', 'mdi-alert', 'red');
          handleFailedBulk(ctx);
        } else {
          clearInterval(ctx.state.intervalSwitch);
          handleFailedBulk(ctx);
          showAlert(ctx, 'Switch Failed!', 'mdi-alert', 'red');
        }
    
        
      } catch (error) {
        clearInterval(ctx.state.intervalSwitch);
        showAlert(ctx, 'Switch Failed!', 'mdi-alert', 'red');
        handleFailedBulk(ctx);
      }
    }
    
  },
};
export default changePIC;
